import angular from 'angular';

import * as CSV from './comingSoonVidoes/comingSoonVideosDir';
import * as F from './footer/footer';
import * as FT from './footerTagline/footerTagline';
import * as SM from './menu/menu';
import * as MB from './modelBlock/modelBlock';
import * as T from './tagline/tagline';
import * as VB from './videoBlock/videoBlock';
import * as VF from './videoFiles/videoFiles';
import * as VP from './videoPlayer/videoPlayer';
import * as SL from './slider/slider';

export default angular.module('core.components', [])
  .directive(CSV.CSVDirName, CSV.CSVDir)
  .directive(F.siteFooterDirName, F.siteFooterDir)
  .directive(FT.footerTaglineDirName, FT.footerTaglineDir)
  .directive(SM.siteMenuDirName, SM.siteMenuDir)
  .directive(MB.modelBlockDirName, MB.modelBlockDir)
  .directive(T.taglineDirName, T.taglineDir)
  .directive(VB.videoBlockDirName, VB.videoBlockDir)
  .directive(VP.videoPlayerDirName, VP.videoPlayerDir)
  .directive(VF.videoFilesDirName, VF.videoFilesDir)
  .directive(SL.sliderDirName, SL.sliderDir)
  .name;



// WEBPACK FOOTER //
// ./~/site_core/src/components/index.js